<eo-base-form-control
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-multiSelect
    [maxSelectedLabels]="getMaxSelectedLabels()"
    [display]="getDisplay()"
    [id]="id"
    [tabindex]="getTabIndex()"
    [options]="getOptions()"
    [optionLabel]="getOptionLabel()"
    [optionValue]="getOptionValue()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [showClear]="getShowClear()"
    [dropdownIcon]="getDropdownIcon()"
    [appendTo]="getAppendTo()"
    attr.aria-describedby="{{ id }}-help"
    styleClass="w-full {{ getInputStyleClass() }}"
    (onRemove)="onRemoveHandler()"
    (onChange)="onChangeHandler($event)"
    (onFocus)="onFocusHandler($event)"
    (onBlur)="onBlurHandler($event)"
    (onChange)="change.emit($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)"
    [virtualScroll]="getVirtualScroll()"
    [virtualScrollItemSize]="getVirtualScrollSize()"
    [group]="getGroup()"
  >
    <ng-content />
  </p-multiSelect>
</eo-base-form-control>
